<template>
  <div>

    <div v-if="getCompetitionPoomsae.id!=0" class="modal fade " tabindex="-1" role="dialog" id="modalAddFile">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
              aria-hidden="true">×</span></button>
            <h4 class="modal-title"> Ajouter un fichier</h4>
          </div>
          <div class="modal-body">
            <UploadFiles
              :urlPost="urlUploadFile"
              @filesUploaded="allFilesUploaded()"
              morph="competitionPoomsae"
              :id_morph="getCompetitionPoomsae.id"
            ></UploadFiles>
          </div>
          <div class="modal-footer">
            <button type="button"
                    class="btn btn-default pull-right" data-dismiss="modal">
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- <b-alert v-if="someResultsAreNotComplientToCategPoidsCompet()" variant="warning" show>
      Certains membres ont été encodés sur une catégorie de poids qui ne correspond pas à la catégorie de poids de la
      compétition.
      Cela peut arriver si vous modifier la catégorie de poids générale de la compétition APRES avoir encodé les
      résultats.
      Pour régler ce problème, il faut réencoder les résultats de ces membres.
    </b-alert> -->

    <form role="form">
      <div class="row">
        <div class="col-md-12">

          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Données de la compétition Poomsae</h3>
              <button type="button"
                      class="btn btn-xs btn-danger btn-flat margin pull-right"
                      style="margin-top: 0;margin-bottom: 0;"
                      @click="supprimerCompetitionPoomsae()"
              >
                Supprimer la compétition Poomsae
              </button>
            </div>

            <div class="box-body">
              <div class="col-md-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('competition[competition]') }">
                  <label for="competition">Nom de la compétition Poomsae</label>
                  <input type="text" class="form-control" id="competition" name="competition[competition]"
                         v-validate="'max:200'"
                         placeholder="Nom de la competition" v-model="getCompetitionPoomsae.competition">
                  <span v-show="errors.has('competition[competition]')" class="help-block">Le nom de la competition doit comporter moins de 200 caractères</span>
                </div>

                <div class="form-group"
                     :class="{'has-error': errors.has('competition[adresse]') }">
                  <label for="adresse">Adresse</label>
                  <textarea type="text" class="form-control" id="adresse" name="competition[adresse]"
                            placeholder="Adresse"
                            v-model="getCompetitionPoomsae.adresse">{{getCompetitionPoomsae.adresse}}</textarea>
                </div>

                <div class="form-group">
                  <label for="ville">Pays</label>
                  <select class="form-control" name="competition[id_pays]" v-model="getCompetitionPoomsae.id_pays">
                    <option value="ZZ">Pays indéterminé
                    </option>
                    <optgroup label="Habituels">
                      <option
                        v-for="pays in getPays.habituels"
                        :value="pays.id"
                      >{{ pays.name }}
                      </option>

                    </optgroup>
                    <optgroup label="Autres">
                      <option
                        v-for="pays in getPays.all"
                        :value="pays.id"
                      > {{ pays.name }}
                      </option>
                    </optgroup>
                  </select>
                  <!--<span class="help-block">Help block with error</span>-->
                </div>

                <!-- <div class="checkbox">
                  <label for="labelise">
                    <input id="labelise" name="competition[labelise]" type="checkbox"
                           v-model="getCompetitionPoomsae.labelise">
                    Labelisé ABFT – Poomsae
                  </label>
                </div> -->

                <div class="form-group clearfix">
                  <label>Secrétariat</label>
                  <p>
                    <!--<button type="button" class="btn btn-primary btn-flat col-xs-4 margin">Ajouter un-->
                    <!--suivi-->
                    <!--</button>-->
                    <button type="button"
                            @click.prevent="showModal('#modalAddFile')"
                            class="btn btn-primary btn-flat col-xs-4 margin">Ajouter un
                      fichier
                    </button>
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="statut">Niveau de la compétition Poomsae</label>
                  <select id="statut" class="form-control" name="competition[id_niveau]"
                          v-model="getCompetitionPoomsae.id_niveau">
                    <option
                      v-for="niveau in getNiveauxCompetitionPoomsae"
                      :value="niveau.id"
                    >{{ niveau.niveau }}
                    </option>
                  </select>
                </div>

                <!-- <div class="checkbox">
                  <label for="jock">
                    <input id="jock" name="competition[jo]" type="checkbox"
                           v-model="getCompetitionPoomsae.jo">
                    Jeux Olympiques (catégorie Poomsae)
                  </label>
                </div>

                <div class="checkbox">
                  <label for="new_categck">
                    <input id="new_categck" name="competition[new_categ]" type="checkbox"
                           v-model="getCompetitionPoomsae.new_categ">
                    Catégories de poids WTF/ABFT
                  </label>
                </div>

                <div class="checkbox">
                  <label for="olympiqueck">
                    <input id="olympiqueck" name="competition[olympique]" disabled type="checkbox"
                           v-model="getCompetitionPoomsae.olympique">
                    Catégorie de poids olympique
                  </label>
                </div>

                <div class="checkbox">
                  <label for="abssociated">
                    <input id="abssociated" name="competition[ab_dissociated]" type="checkbox"
                           v-model="getCompetitionPoomsae.ab_dissociated">
                    Catégories de poids A et B séparées (ex.: Indoor Brussels)
                  </label>
                </div> -->

                <date-avant-date-apres
                  :dateDebutPrefill="this.getCompetitionPoomsae.date_debut"
                  :dateFinPrefill="this.getCompetitionPoomsae.date_fin"
                  @onDateDebutChange="setDateDebut"
                  @onDateFinChange="setDateFin"
                ></date-avant-date-apres>

                <div class="form-group"
                     :class="{'has-error': errors.has('competition[comments]') }">
                  <label for="adresse">Commentaires</label>
                  <textarea type="text" class="form-control" id="comments" name="competition[comments]"
                            placeholder="Commentaires éventuels"
                            v-model="getCompetitionPoomsae.comments">{{getCompetitionPoomsae.comments}}</textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li class="active">
                <a href="#tab_1" data-toggle="tab" aria-expanded="false">Fichiers liés – compétition Poomsae</a>
              </li>
            </ul>

            <div class="tab-content">
              <div class="tab-pane active" id="tab_1">
                <b-table
                  id="tableFilesMember"
                  responsive bordered striped hover
                  :items="getCompetitionPoomsae.file"
                  :fields="filesOptions.columns"
                  :current-page="filesOptions.pagination_meta.current_page"
                  :per-page="filesOptions.pagination_meta.per_page"
                  :empty-text="'Aucun résultat'"
                  :empty-filtered-text="'Aucun résultat'"
                  foot-clone
                  show-empty
                >
                  <template slot="created_at" slot-scope="row">
                    {{ row.item.date }}
                  </template>
                  <template slot="link" slot-scope="row">
                    <a :href="getProcessEnv.STORAGE_URL+row.item.nom" target="_blank">
                      {{ row.item.titre }}
                    </a>
                  </template>
                </b-table>
                <b-pagination size="md"
                              :total-rows="getCompetitionPoomsae.file.length"
                              v-model="filesOptions.pagination_meta.current_page"
                              :per-page="filesOptions.pagination_meta.per_page">
                </b-pagination>
              </div>
              <!-- /.tab-pane -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="box ">
            <div class="overlay"
                 v-if="this.disabledBtn">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-body">
            </div>
            <div class="box-footer">
              <button type="button"
                      class="btn btn-lg btn-primary btn-flat margin pull-right"
                      :disabled="errors.count()!=0 || this.disabledBtn || this.loadingInputs.length>0"
                      @click="sendForm()">
                Enregistrer les modifications
              </button>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import vSelect from '../../Communs/vSelect/index'
import DateAvantDateApres from '../../Communs/DateAvantDateApres'
import UploadFiles from '../../Communs/UploadFiles'

var $ = require('jquery');
var variables = require('../../../assets/js/variables')
var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');

export default {
  props: {
    loadingTableMembres: {
      required: true,
      'default': false
    },
  },
  data() {
    return {
      loadingInputs: [],
      disabledBtn: false,
      resize: false,
      filesOptions: {
        columns: [
          {
            label: 'Date',
            key: 'created_at',
            sortable: true,
          },
          {
            label: 'Link',
            key: 'link',
            sortable: true,
          },
          {
            label: 'Nom',
            key: 'titre',
            sortable: false,
          },
          {
            label: 'Responsable',
            key: 'user',
            sortable: true,
          },
        ],
        pagination_meta: {
          current_page: 1,
          from: 1,
          last_page: 1,
          path: "",
          per_page: 40,
          to: 1,
          total: 1
        },
      },
      activeTab: "default",
      redraw: "",
      loadingSecretariatBox: false,
      loadingMembres: false,
      licencesMembres: [],
      currentPage: 1,
      perPage: 10,
      urlUploadFile: '',
      addFileUpload: null,
      columnsMembres: [
        {
          label: 'Num. Inscription',
          key: 'id',
          sortable: true,
        },
        {
          label: 'Nom',
          key: 'nom',
          sortable: true,
        },
        {
          label: 'Montant',
          key: 'montant',
          sortable: true,
        },
        {
          label: 'Actions',
          key: 'actions',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getNiveauxCompetitionPoomsae: 'getNiveauxCompetitionPoomsae',
      getCompetitionPoomsae: 'getCompetitionPoomsae',
      getCategAgePoomsae: 'getCategAgePoomsae',
      getCategGradePoomsae: 'getCategGradePoomsae',
      getPays: 'getPays',
      getProcessEnv: 'getProcessEnv',
    }),
  },
  mounted: function () {
    var these = this
    this.urlUploadFile = this.getRoute('Secretariat.addFile');
  },
  created() {
    // this.getTableMembres();

  },
  beforeRouteEnter(to, from, next) {
    // this.getTableMembres();
    next()
  },
  watch: {},
  components: {
    vSelect,
    DateAvantDateApres,
    UploadFiles,
  },
  methods: {
    ...mapActions({}),
    showModal: function (id) {
      $(id).modal('show')
    },
    closeModal: function (id) {
      $(id).modal('hide')
    },
    refreshListFiles: function () {
      this.$http.get(this.getRoute('getFilesCompetPoomsae') + this.getCompetitionPoomsae.id)
        .then((response) => {
          this.getCompetitionPoomsae.file = response.body.file
        }, (response) => {
        });
    },

    allFilesUploaded: function () {
      this.closeModal("#modalAddFile")
      this.refreshListFiles()
    },
    setDateDebut: function (value) {
      this.getCompetitionPoomsae.date_debut = value;
    },
    setDateFin: function (value) {
      this.getCompetitionPoomsae.date_fin = value;
    },
    formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
      if (value == null) return ''
      return moment(value, fmtIn).format(fmtOut)
    },
    currentYear: function () {
      return moment().year();
    },
    getTableMembres: function () {
      this.loadingMembres = true;
    },
    isTableMembresLoading: function (force = false) {
      if (force)
        return true
      return this.loadingTableMembres;
    },
    constructForm: function () {
      return JSON.stringify({
        "competition": this.getCompetitionPoomsae.competition,
        "adresse": this.getCompetitionPoomsae.adresse,
        "date_debut": this.formatDate(this.getCompetitionPoomsae.date_debut, "DD/MM/YYYY", "YYYY-MM-DD"),
        "date_fin": this.formatDate(this.getCompetitionPoomsae.date_fin, "DD/MM/YYYY", "YYYY-MM-DD"),
        "id_pays": this.getCompetitionPoomsae.id_pays,
        // "labelise": this.getCompetitionPoomsae.labelise,
        "id_niveau": this.getCompetitionPoomsae.id_niveau,
        // "jo": this.getCompetitionPoomsae.jo,
        // "new_categ": this.getCompetitionPoomsae.new_categ,
        // "ab_dissociated": this.getCompetitionPoomsae.ab_dissociated,
        // "olympique": this.getCompetitionPoomsae.olympique,
        "comments": this.getCompetitionPoomsae.comments,
      })
    },
    supprimerCompetitionPoomsae: function () {
      let these = this
      let self = this
      this.$dialog.confirm('' +
        'Confirmez-vous la suppression de la compétition Poomsae ?<br/><br/> ' +
        'Toutes les inscriptions à cette competition seront supprimées également. ',
        {
          html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: 'Supprimer la competition Poomsae',
          cancelText: 'Annuler',
          animation: 'zoom', // Available: "zoom", "bounce", "fade"
          type: 'basic', // coming soon: 'soft', 'hard'
        })
        .then(function (dialog) {
          setTimeout(() => {
            self.$http.post(self.getRoute('Secretariat.competitionPoomsae.delete'), {id_competition: self.getCompetitionPoomsae.id})
              .then(function (response) {
                self.$noty.success("Competition supprimée")
                self.$router.push('/');
                dialog.close();
              }, (response) => {
                self.$noty.success("Erreur dans la suppression")
                dialog.close();
              });
          }, 1000);
        })
        .catch(function () {
          // console.log('Clicked on cancel')
        });
    },
    sendForm: function () {
      this.disabledBtn = true;
      let self = this;
      this.$http.put(this.getRoute('Secretariat.competitionPoomsae.update') + this.getCompetitionPoomsae.id, this.constructForm()).then(function (response) {
        self.$noty.success("Le compétition Poomsae a bien été modifiée")
        this.getCompetitionPoomsae.participations = response.body
        this.disabledBtn = false
      }, (response) => {
        self.$noty.error("Erreur dans la sauvegarde de la compétition Poomsae")
        this.disabledBtn = false
      });
    },
    isInputLoading: function (input) {
      return _.indexOf(this.loadingInputs, input) >= 0 ? true : false
    },
    addToLoadingInputs: function (input) {
      this.loadingInputs.push(input)
    },
    removeFromLoadingInputs: function (input) {
      this.loadingInputs = _.without(this.loadingInputs, input)
    },
  },
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/CompetitionPoomsae/MainFormCompetitionPoomsae.vue